import script from "./userAvatar.vue?vue&type=script&setup=true&lang=ts"
export * from "./userAvatar.vue?vue&type=script&setup=true&lang=ts"

import "./userAvatar.vue?vue&type=style&index=0&id=1afde003&scoped=true&lang=scss"

import exportComponent from "E:\\项目对接\\parent-reporting-backend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1afde003"]])

export default __exports__